import { CREATE_BASVURU_IMZACI_LIST } from "../constants/requestUrls";
import {  postRequest } from "../request";

const CreateBasvuruImzaciList = (props) => {

    let data = {};
    if (props !== undefined)
      data = JSON.stringify(props);

    return postRequest({url:CREATE_BASVURU_IMZACI_LIST,data});
}

export default CreateBasvuruImzaciList;